/* eslint-disable import/max-dependencies */
/* eslint-disable max-lines-per-function */
import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import { debounce } from "lodash";
import { InputText } from "@loanbossinc/component-library";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment";

import { PaddedWrapper } from "../line-item-management/styles";
import { actionCreators as drawerAcitonCreators } from "../lenderReportingDrawer.store";
import { actionCreators as fieldActionCreators } from "../field-management/fieldManagement.store";
import { dealGet } from "../../../deal/deal.store";
import { actionCreators as dscrLineItemActionCreators } from "./dscrLineItemManagement.store";
import FieldListItem from "../line-item-management/formulaFields/FieldListItem";
import { Container, StyledSecondaryButton, StyledSearchHeader, ButtonWrapper } from "../line-item-management/formulaFields/styles";
import { filterNonMonetaryFields } from "../line-item-management/formulaFields/util";

const CALCULATION_COMPONENT_TYPES = { REGULAR:"regular", COMPARISON_1:"comparison1", COMPARISON_2: "comparison2" };
const DscrFromFile = props => {
  const {
    deal,
    fields,
    getFields,
    isMultipleProperties,
    newLineItemType,
    singlePropertyComparisonCards,
    setDrawerSelections,
    setFieldSelections,
    propertyIdSelected,
    multiplePropertiesComparisonFields,
    accountingIntegrations,
    setDscrLineItemSelections,
    selectedFromFileField,
    isComparison,
    calculationComponentType,
    allFilesForDeal,
    getAllFilesForDeal,
    calculationFieldsInputValues,
    comparisonCalculationFieldsInputValues1,
    comparisonCalculationFieldsInputValues2,
    match: {
      params: { dealId }
    }
  } = props;

  const [filteredFields, setFilteredFields] = useState(null);

  useEffect(() => {
      getAllFilesForDeal({ dealId });
  }, []);

  useEffect(()=>{
    if(calculationFieldsInputValues && calculationFieldsInputValues.length > 0){
      setDscrLineItemSelections({selectedFromFileField: calculationFieldsInputValues[0]});
    }
    else if(comparisonCalculationFieldsInputValues1 && comparisonCalculationFieldsInputValues1.length > 0){
      setDscrLineItemSelections({selectedFromFileField: comparisonCalculationFieldsInputValues1[0]});
    }
    else if(comparisonCalculationFieldsInputValues2 && comparisonCalculationFieldsInputValues2.length > 0){
      setDscrLineItemSelections({selectedFromFileField: comparisonCalculationFieldsInputValues2[0]});
    }
    else {
      setDscrLineItemSelections({selectedFromFileField: null });
    }
  },[]);

  useEffect(() => {
    getFields({ dealId });
  },[]);

  const mapFromFileModel = (field) => {
    const sortedByRecentDate = [...allFilesForDeal].sort((a,b) => moment(b.createdAt).valueOf - moment(a.createdAt).valueOf);
    const sourceFile = sortedByRecentDate.find(d => d.id === field.sourceFileId);
    if (sourceFile) {
          const { typeName, createdAt, sourceName, asOfDate } = sourceFile;

          let propertyName = "Deal";
          if (
            sourceFile.propertyId &&
            sourceFile.propertyId !== "-1"
          ) {
            const dealProperty =
              Boolean(deal) &&
              deal.properties.find(x => x.id === sourceFile.propertyId);
            if (dealProperty) {
              propertyName = dealProperty.name;
            } else {
              propertyName = "Property";
            }
          }

          return {
            lineItemType: "fromFile",
            fileTypeName: typeName,
            fileCreatedAt: createdAt,
            name: field.name,
            propertyName,
            sourceName,
            value: field.value,
            id:field.id,
            asOfDate,
            fieldName: "From file"
          };
    }
    return field;
  };

  useEffect(() => {
    // logic of excluding fields that have been already selected
    if (newLineItemType === "comparison") {
      if (!isMultipleProperties) {
        const selectedFieldsIds = singlePropertyComparisonCards.map(card => card.selectedField && card.selectedField.id);
        const filtered = fields?.filter(field => !selectedFieldsIds.includes(field.id));
        const monetaryFields = filterNonMonetaryFields(filtered);
        const excludedFields = excludeFields(monetaryFields);
        setFilteredFields(excludedFields);
      } else {
        const fieldIdsToExclude = [];
        for (const propField of multiplePropertiesComparisonFields) {
          const selectedProp = propField.find(prop => prop.propertyId === propertyIdSelected);
          if (selectedProp && selectedProp.selectedField) {
            fieldIdsToExclude.push(selectedProp.selectedField.id);
          }
        }
        const fieldsWithSelectedExcluded = fields?.filter(field => !fieldIdsToExclude.includes(field.id));
        const monetaryFieldsWithSelectedExcluded = filterNonMonetaryFields(fieldsWithSelectedExcluded);
        const excludedFields = excludeFields(monetaryFieldsWithSelectedExcluded);
        setFilteredFields(excludedFields);
      }
    } else {
      const monetaryFields = filterNonMonetaryFields(fields);
      const excludedFields = excludeFields(monetaryFields);
      setFilteredFields(excludedFields);
    }
  }, [fields, newLineItemType, isMultipleProperties, singlePropertyComparisonCards, multiplePropertiesComparisonFields, propertyIdSelected]);

  const getFilteredFieldsByName = searchTerm => filterNonMonetaryFields(fields).filter(field => field && field.name && field.name.toLowerCase().includes(searchTerm));

  const handleSearchByName = e => {
    e.persist();

    const debounceDelay = 500;
    const handleSearchDebounce = debounce(event => {
      if (event.target.value) {
        const filtered = getFilteredFieldsByName(event.target.value.toLowerCase());
        setFilteredFields(filtered);
      } else {
        const monetaryFields = filterNonMonetaryFields(fields);
        const excludedFields = excludeFields(monetaryFields);
        setFilteredFields(excludedFields);
      }
    }, debounceDelay);

    handleSearchDebounce(e);
  };

  const excludeFields = (fs) => fs?.filter(f => !f.isFromRentRoll || !f.isBalanceOverride);

  const onAddNewHandler = () => {
    setDrawerSelections({ currentSectionName: "field-management", isFromDscrFromFile: true });
    setFieldSelections({ isAdding: true, isFromDscrFromFile: true });
  };

  const onSelectedField = field => {
    // if it's a file field get the file data
    const fieldModel = field.type === "file" ? mapFromFileModel(field) : field;
    switch(calculationComponentType) {
      case CALCULATION_COMPONENT_TYPES.REGULAR:
        setDscrLineItemSelections({selectedFromFileField: fieldModel, resultValue: field.value});
          break;
        case CALCULATION_COMPONENT_TYPES.COMPARISON_1:
        setDscrLineItemSelections({selectedFromFileField: fieldModel, calculatedComparisonValue1: field.value});
          break;
          case CALCULATION_COMPONENT_TYPES.COMPARISON_2:
          setDscrLineItemSelections({selectedFromFileField: fieldModel, calculatedComparisonValue2: field.value});
            break;
          default:
            setDscrLineItemSelections({selectedFromFileField: fieldModel, resultValue: field.value});
    }
  };
  return (
    <Container>
      {!isComparison &&
      <StyledSearchHeader>
        <Grid container alignItems="center">
          <Grid item xs={9}>
            <PaddedWrapper>
              <InputText
                onChange={handleSearchByName}
                variant="filled"
                id="search-field-by-name"
                name="search-field-by-name"
                label="Search fields by name"
                fullWidth
              />
            </PaddedWrapper>
          </Grid>
          <Grid item xs={3}>
            <ButtonWrapper>
              <StyledSecondaryButton label="Add new" onClick={onAddNewHandler} />
            </ButtonWrapper>
          </Grid>
        </Grid>
      </StyledSearchHeader>
      }
      {filteredFields &&
        filteredFields.map(field => (
          <FieldListItem
            field={field}
            key={field.id}
            onSelectedField={onSelectedField}
            isSelected={field?.id === selectedFromFileField?.id}
            accountingIntegrations={accountingIntegrations}
            propertyIdSelected={propertyIdSelected}
          />
        ))}
    </Container>
  );
};

const mapStateToProps = ({
  lenderReportFieldManagement: { fields },
  newDeal: { deal },
  lenderReportList: { selectedReportGroup },
  lenderReportDscrLineItemManagement: { selectedFromFileField,
                                        calculationFieldsInputValues,
                                        comparisonCalculationFieldsInputValues1,
                                        comparisonCalculationFieldsInputValues2 },
  lenderReportingDrawer: { allFilesForDeal }
}) => ({ fields, selectedReportGroup, allFilesForDeal, deal, selectedFromFileField,
                                                             calculationFieldsInputValues,
                                                             comparisonCalculationFieldsInputValues1,
                                                             comparisonCalculationFieldsInputValues2 });

const mapDispatchToProps = dispatch => bindActionCreators({ dealGet, ...drawerAcitonCreators, ...fieldActionCreators, ...dscrLineItemActionCreators }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DscrFromFile);
